import { Button } from "react-aria-components";
import IconCases from "../../../assets/icons/icon-cases-orange.svg"
import IconDisposal from "../../../assets/icons/icon-disposal-orange.svg"
import * as Navigation from "../../../modules/Navigation";
import { useNavigate } from "react-router";
import { EntityNames } from "../../../enums/EntityNames";
import { UserScopes } from "../../../enums/UserScopes";
import { usePermissions, useUserScope } from "../../../modules/auth/Permissions/PermissionContext";
import { hasPermission } from "../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../modules/auth/Permissions/PermissionStrings";

export default function RequestsLandingView() {
    const navigate = useNavigate();
    const { permissions } = usePermissions();
    const userScope = useUserScope();

    function handleClick(entityName: string) {
        Navigation.Requests.navigate(navigate, entityName)
    }

    const hasRecallRequestsRead = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Recall_Requests);
    const hasNavigationRecallsOperators = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Navigation_Recalls_Operators);
    const hasNavigationRecallsCustomers = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Navigation_Recalls_Customers);
    const hasDisposalRequestsRead = hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Disposal_Requests);

    const canViewRecalls = userScope === UserScopes.CellTrak && (hasNavigationRecallsOperators || hasRecallRequestsRead);
    
    // For Customer users: show customer recalls if they have the permission
    const canViewRecallsCustomer = userScope === UserScopes.Customer && hasNavigationRecallsCustomers;
    const canViewDisposals = hasDisposalRequestsRead;

    return (<>
        <div className="grid-x grid-margin-x padding__top-bottom--s padding__left-right--l">
            {/* Recalls */}
            {canViewRecalls &&
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.operatorRecalls)}>
                    <img alt='' src={IconCases} />
                    <h2 className={"landing-page__button-text"}>Recalls</h2>
                </Button>
            }
            {canViewRecallsCustomer &&
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.customerRecalls)}>
                    <img alt='' src={IconCases} />
                    <h2 className={"landing-page__button-text"}>Recalls</h2>
                </Button>
            }
            {canViewDisposals &&
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.disposals)}>
                    <img alt='' src={IconDisposal} />
                    <h2 className={"landing-page__button-text"}>Disposals</h2>
                </Button>
            }

            {/* Uplifts */}
            {/* {hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Navigation_Uplifts_Operators) &&
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.operatorUplifts)}>
                    <img alt='' src={IconCases} />
                    <h2 className={"landing-page__button-text"}>Uplifts</h2>
                </Button>
            }
            {hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Navigation_Uplifts_Customers) &&
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.customerUplifts)}>
                    <img alt='' src={IconCases} />
                    <h2 className={"landing-page__button-text"}>Uplifts</h2>
                </Button>
            } */}

            {/* Returns */}
            {/* {( hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Navigation_Returns_Operators)) &&
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.operatorReturns)}>
                    <img alt='' src={IconContainer} />
                    <h2 className={"landing-page__button-text"}>Returns</h2>
                </Button>
            }
            {(true ||hasPermission(permissions!, PermissionTypes.read, PermissionConcerns.Navigation_Returns_Customers)) &&
                <Button className={"landing-page__button cell small-6"} onPress={() => handleClick(EntityNames.customerReturns)}>
                    <img alt='' src={IconContainer} />
                    <h2 className={"landing-page__button-text"}>Returns</h2>
                </Button>
            } */}
        </div>
    </>)
}
